import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export default async function importPnr(data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: `/product/v1/book/importBookingAsAdmin`,
    data,
  })
    .then((res) => {
      // console.log(" => ",{...res})
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successfull", data: res.data?.data };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);

      // result = {return: 1,msg: 'Successfull',data:[]}
    });

  return result;
}

export async function saveImportedPnr(data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: `/product/v1/book/saveImportedAsAdmin`,
    data,
  })
    .then((res) => {
      // console.log(" => ",{...res})
      if (res) {
        if (res.status === 201) {
          result = { return: 1, msg: "Successfull", data: res.data?.data };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);

      // result = {return: 1,msg: 'Successfull',data:[]}
    });

  return result;
}
